export type ErrorMessages = {
  errorTitle: string;
  errorDescription: string;
  errorBankAccountDescription: string;
  errorAlt: string;
};

export const ERROR_MESSAGES: ErrorMessages = {
  errorTitle: "Erro",
  errorDescription: "Ocorreu um erro ao carregar o saldo da conta",
  errorBankAccountDescription: "Ocorreu um erro ao carregar as contas",
  errorAlt: "Erro ao carregar o saldo da conta",
};
